<template>
    <form id="frm_product" @submit.prevent="productAdd">
        <div class="alert_msg_body">
            <div
                v-if="errors"
                class="alert alert-danger alert-dismissible fade show bg-danger text-white alert_msg_box"
                role="alert"
            >
                <p>Please correct the following error.</p>
                <ul v-for="(v, k) in errors" :key="k">
                    <li v-for="error in v" :key="error">{{ error }}</li>
                </ul>
                <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="category_id">Product Category</label>
                    <select
                        class="form-control"
                        name="category_id"
                        v-model="formData.category_id"
                        @change="getSubCategory()"
                    >
                        <option value="null">Select Category</option>
                        <option
                            v-for="data in category"
                            :key="data.id"
                            :value="data.id"
                        >
                            {{ data.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="sub_category">Product Sub Category</label>
                    <select
                        class="form-control"
                        name="sub_category"
                        v-model="formData.sub_category"
                        @change="getAttribute()"
                    >
                        <option value="null">Select Sub Category</option>
                        <option
                            v-for="data in subCategory"
                            :key="data.id"
                            :value="data.id"
                        >
                            {{ data.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="category_id">Add Image File</label>

            <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                :data-images="formData.images"
                :show-edit="false"
                primary-text="Primary Image"
                mark-is-primary-text=""
                browse-text="Upload Images"
                drag-text="Upload Images"
                popup-text="Upload Only jpg,jpeg,png"
            >
            </vue-upload-multiple-image>
        </div>

        <div class="address_row_wrapper_bg">
            <label for="category_id">Select Pickup Address</label>
            <div class="text-right">
                <button
                    type="button"
                    class="btn btn-success"
                    title="Add Pickup Address"
                    @click="openModal()"
                >
                    <i class="las la-plus"></i> Add Pickup Address
                </button>
            </div>
            <div class="adress_row_wrapper mt-3">
                <div
                    class="address_card_info_box"
                    v-for="(loc, index) in this.address"
                    :key="index"
                >
                    <div class="card">
                        <div class="card-body p-2">
                            <div class="form-check form-check-inline">
                                <input
                                    type="radio"
                                    name="address_id"
                                    v-model="formData.address_id"
                                    id="address_ids"
                                    :value="index"
                                />
                            </div>
                            <b> {{ loc }} </b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-for="data in attribute"
            :key="data.attribute.id"
            :value="data.attribute.id"
        >
            <div
                class="form-group"
                v-if="
                    (data.attribute.type == 'text' ||
                        data.attribute.type == 'textarea') &&
                    attribute.length > 0
                "
                :key="data.id"
            >
                <label for="Name">{{ data.attribute.admin_name }}</label>
                <input
                    class="form-control"
                    :type="data.attribute.type"
                    :placeholder="'Enter ' + data.attribute.admin_name"
                    :name="data.attribute.code"
                    v-model="formData[data.attribute.code]"
                />
            </div>
            <div
                class="form-group"
                v-if="data.attribute.type == 'select' && attribute.length > 0"
                :key="data.id"
            >
                <label for="Name">{{ data.attribute.admin_name }} </label>
                <select
                    v-model="formData[data.attribute.code]"
                    class="form-control"
                    :name="data.attribute.admin_name"
                >
                    <option
                        v-for="attribute_options_data in data.attribute_options"
                        :key="attribute_options_data.id"
                        :value="attribute_options_data.id"
                    >
                        {{ attribute_options_data.admin_name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="points">Points</label>
            <input class="form-control" readonly v-model="formData.points" />
        </div>

        <div v-if="check_group" class="form-group">
            <label for="product_group">Group</label>
            <select
                class="form-control"
                :name="product_group"
                v-model="formData.product_group"
            >
                <option value="open">All Users</option>
                <option value="close">Only Group</option>
            </select>
        </div>
        <div class="form-group">
            <button class="btn btn-success" type="submit">Save</button>
            <a :href="'/my/reuse'" class="btn btn-danger" title="Cancel"
                >Cancel</a
            >
        </div>
        <div
            class="modal fade address_popup"
            data-backdrop="static"
            id="myModals"
            role="dialog"
        >
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-dark">
                            Add Pickup Address
                        </h4>
                        <button
                            type="button"
                            class="btn btn-danger close"
                            title="Close"
                            data-dismiss="modal"
                        >
                            <i class="las la-times"></i>
                        </button>
                    </div>

                    <form @submit.prevent="add_address" id="user_address">
                        <div class="modal-body">
                            <div class="form-group">
                                <label
                                    >Flat, House no., Building, Company,
                                    Apartment:</label
                                >
                                <input
                                    type="text"
                                    name="addrees_line_1"
                                    v-model="locationData.addrees_line_1"
                                    id="addrees_line_1"
                                    class="form-control"
                                    value=""
                                />
                            </div>
                            <div class="form-group">
                                <label>Area, Street, Sector, Village:</label>
                                <input
                                    type="text"
                                    name="addrees_line_2"
                                    v-model="locationData.addrees_line_2"
                                    id="addrees_line_2"
                                    class="form-control"
                                    value=""
                                />
                            </div>
                            <div class="form-group">
                                <label>Landmark:</label>
                                <input
                                    type="text"
                                    name="addrees_line_3"
                                    v-model="locationData.addrees_line_3"
                                    id="addrees_line_3"
                                    class="form-control"
                                    value=""
                                />
                            </div>
                            <div class="form-group">
                                <label>Pincode:</label>
                                <input
                                    type="text"
                                    name="address_postal_code"
                                    v-model="locationData.address_postal_code"
                                    id="address_postal_code"
                                    class="form-control"
                                    value=""
                                />
                            </div>
                            <div class="form-group">
                                <label>City:</label>
                                <input
                                    type="hidden"
                                    name="let"
                                    id="let"
                                    v-model="locationData.let"
                                />
                                <input
                                    type="hidden"
                                    name="lng"
                                    id="lng"
                                    v-model="locationData.lng"
                                />
                                <vue-google-autocomplete
                                    name="address"
                                    id="map"
                                    class="form-control"
                                    placeholder="Select Location"
                                    v-on:placechanged="getAddressData"
                                    types="(cities)"
                                >
                                </vue-google-autocomplete>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                class="btn btn-success"
                                title="Submit"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    name: "ProductForm",
    components: {
        VueUploadMultipleImage,
        VueGoogleAutocomplete,
    },
    data() {
        return {
            category: [],
            address: [],
            check_group,
            subCategory: [],
            attribute: [],
            addressData: {
                latitude: null,
                longitude: null,
            },
            page: "Add",
            type: "product_image",
            product_group: null,
            formData: {
                category_id: null,
                sub_category: null,
                points: null,
                product_group: null,
                product_id: 0,
                location: null,
                images: [],
                let: null,
                lng: null,
            },
            locationData: {
                addrees_line_1: null,
                addrees_line_2: null,
                addrees_line_3: null,
                address_postal_code: null,
                lng: null,
                locations: null,
                let: null,
            },
            errors: null,
        };
    },
    created() {
        this.getCategory();

        var slug =
            /[^/]*$/.exec(location.href)[0] == "product"
                ? ""
                : /[^/]*$/.exec(location.href)[0];
        if (slug != "") {
            this.page = "Edit";

            this.getProduct(slug);
        }
    },
    methods: {
        getProduct(slug) {
            $(".preloader").show();
            axios
                .get("/my/reuse/get_reuse_data", {
                    params: {
                        slug: slug,
                        type: "getProduct",
                    },
                })
                .then((response) => {
                    this.formData.category_id = response.data[1].category_id;
                    this.getSubCategory();
                    this.formData.sub_category =
                        response.data[2].sub_category_id;
                    this.attribute = response.data[0].getProduct;
                    this.formData.images = response.data[5].images;
                    this.formData.product_id = response.data[6].product_id;
                    this.formData.address_id = response.data[9].address_id;
                    this.formData.location = response.data[8].location_text;
                    this.formData.let = response.data[3].let;
                    this.formData.lng = response.data[4].long;
                    this.formData.product_group =
                        response.data[7].product_group;
                    this.formData.points = response.data.points.reuse_points;
                    for (var k in this.attribute) {
                        this.formData[this.attribute[k].attribute.code] =
                            this.attribute[k].product_attribute[0].value;
                    }

                    $(".preloader").hide();
                })

                .catch((error) => {
                    $(".preloader").hide();
                    console.log(error);
                });
        },
        add_address() {
            if (
                this.locationData.lng == null &&
                this.locationData.let == null
            ) {
                swal({
                    title: "Please Select From Google Location",
                    icon: "error",
                });
                $("#map").val("");
            }
            axios
                .post("/my/reuse/add_loction", this.locationData)
                .then((response) => {
                    this.address = response.data.address;
                    $("#myModals").modal("hide");
                    this.locationData.addrees_line_1 = "";
                    this.locationData.addrees_line_2 = "";
                    this.locationData.addrees_line_3 = "";
                    this.locationData.address_postal_code = "";
                    this.locationData.lng = "";
                    this.locationData.let = "";
                    $("#map").val("");
                })
                .catch((error) => {
                    this.errors = "";
                    this.errors = error.response.data.errors;
                });
        },
        openModal() {
            $("#myModals").modal();
        },
        productAdd(e) {
            $(".preloader").show();
            axios
                .post("/my/reuse/store", this.formData)
                .then((response) => {
                    $(".preloader").hide();
                    var message = "";
                    console.log(response.data.age);
                    if (response.data.age > 18) {
                        message =
                            "Your Product " +
                            this.page +
                            "ed Successfully,it will be published when approved by Site Admin";
                    } else {
                        message =
                            "Your Product " +
                            this.page +
                            "ed Successfully,it will be published when approved by Guardian & Site Admin";
                    }

                    console.log(message);
                    swal({
                        title: message,
                        icon: "success",
                    }).then((value) => {
                        window.location.href = "/my/reuse";
                    });
                })
                .catch((error) => {
                    $(".preloader").hide();
                    // this.errors = "";

                    this.errors = error.response.data.errors;
                });
            e.preventDefault();
        },
        getAddressData: function (addressData, placeResultData, id) {
            this.locationData.let = addressData.longitude;
            this.locationData.lng = addressData.latitude;
            this.formData.location = placeResultData.formatted_address;
            this.locationData.locations = JSON.stringify(placeResultData);
        },
        // async getStreetAddressFrom(lat, long) {
        //   axios
        //     .get("/getLocation?lat=" + lat + "&long=" + long)
        //     .then((response) => {
        //       for (var m in response.data.results) {
        //         if (
        //           response.data.results[m].types[0] == "administrative_area_level_2"
        //         ) {
        //           this.locationData.let = lat;
        //           this.locationData.lng = long;
        //         }
        //       }
        //     })
        //     .catch((error) => {
        //     });
        // },
        uploadImageSuccess(formData, index, fileList) {
            this.formData.images = fileList;
        },
        beforeRemove(index, done, fileList) {
            swal({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this image file!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    axios
                        .post("/my/reuse/deletesfile", {
                            id: fileList[index]["id"],
                        })
                        .then((response) => {})
                        .catch((error) => {
                            this.errors = "";
                            this.errors = error.response.data.errors;
                        });
                    done();
                }
            });
        },
        editImage(formData, index, fileList) {
            this.formData.images = fileList;
        },
        getPostFrom(url, para = {}) {
            axios
                .post(url, {
                    params: {
                        category: this.formData.category_id,
                        subCategory: this.formData.sub_category,
                    },
                })
                .then((response) => {
                    this.category = response.data.category;
                    this.subCategory = response.data.subCategory;
                    this.attribute = response.data.attribute;
                    this.product = response.data.product;
                    this.product_group = response.data.product_group;
                })
                .catch((error) => {
                    this.errors = "";
                    this.errors = error.response.data.errors;
                });
        },
        getCategory() {
            $(".preloader").show();
            axios
                .get("/my/reuse/get_reuse_data", {
                    params: {
                        category: this.formData.category_id,
                        type: "category",
                    },
                })
                .then((response) => {
                    this.category = response.data.category;
                    this.address = response.data.address;
                    this.subCategory = response.data.subCategory;
                    $(".preloader").hide();
                })
                .catch((error) => {
                    $(".preloader").hide();
                    console.log(error);
                });
        },
        getSubCategory() {
            $(".preloader").show();
            axios
                .get("/my/reuse/get_reuse_data", {
                    params: {
                        category_id: this.formData.category_id,
                        type: "subCategory",
                    },
                })
                .then((response) => {
                    this.subCategory = response.data.subCategory;
                    $(".preloader").hide();
                })
                .catch((error) => {
                    console.log(error);
                    $(".preloader").hide();
                });
        },
        getAttribute() {
            $(".preloader").show();
            axios
                .get("/my/reuse/get_reuse_data", {
                    params: {
                        category_id: this.formData.category_id,
                        sub_category: this.formData.sub_category,
                        product_id: this.formData.productId,
                        type: "attribute",
                    },
                })
                .then((response) => {
                    console.log(response.data.points.reuse_points);
                    this.attribute = response.data.attribute;
                    this.formData.points = response.data.points.reuse_points;
                    $(".preloader").hide();
                })
                .catch((error) => {
                    $(".preloader").hide();
                    console.log(error);
                });
        },
    },
};
</script>
